import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation",
  "use": "exclamation-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 25\" id=\"exclamation\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.816 7.834a1.184 1.184 0 0 1 2.368 0v5.684a1.184 1.184 0 0 1-2.368 0V7.834ZM12 18.018a1.184 1.184 0 1 0 0-2.368 1.184 1.184 0 0 0 0 2.368Z\" clip-rule=\"evenodd\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 19.439a7.105 7.105 0 1 0 0-14.21 7.105 7.105 0 0 0 0 14.21Zm0 1.895a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol